export var BitIndicatorLightCondition;
(function (BitIndicatorLightCondition) {
    /**
     * OFF
     */
    BitIndicatorLightCondition[BitIndicatorLightCondition["Off"] = 0] = "Off";
    /**
     * ON
     */
    BitIndicatorLightCondition[BitIndicatorLightCondition["On"] = 1] = "On";
})(BitIndicatorLightCondition || (BitIndicatorLightCondition = {}));
